export default {
  LESS_MARGIN: 1,
  LESS_AMT: 2,
  EQUAL: 3,
  MORE_AMT: 4,
  MORE_MARGIN: 5
}
